import * as angular from 'angular';

import { ComponentDefinition } from '@models/index';

class MarkdownEditorPopoverController implements angular.IComponentController {
    isPopoverOpen: boolean;
    model: string;
    placeholder = 'Documentation';

    readonly formController: angular.IFormController;
    readonly name: string;
    readonly placement?: string;

    static $inject = [];

    onChange() {
        if (this.formController && this.formController[this.name]) {
            this.formController[this.name].$setDirty();
        }
    }
}

export const wtMarkdownEditorPopover: ComponentDefinition = {
    componentId: 'wtMarkdownEditorPopover',
    controller: MarkdownEditorPopoverController,
    template: require('./markdownEditorPopover.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '<',
        model: '=',
        name: '<',
        placement: '<?'
    }
};
